import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeleteHospitalUsecase {
  constructor(private readonly hospitalRepo: HospitalRepository) {}

  async execute(hospitalCode: string): Promise<SATResult<void, SATError>> {
    return this.hospitalRepo.deleteHospitalInfo({ hospitalCode });
  }
}
